// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmbedPodcast_wrapper__tho8G","abo":"EmbedPodcast_abo__K5w7t"};